/**
 * O vocabulário do evento `busca` — os valores que o WORKER publica, copiados
 * daqui do lado de lá (spec-001 `pesquisa-internet-chat`, [T101]/[T106]).
 *
 * Arquivo próprio, e não literal no util: são constantes de CONTRATO, não copy.
 * Cada uma tem o `arquivo:linha` do produtor ao lado — renomear lá e não aqui
 * derruba a classificação em silêncio (o `_processEvent` ignora divergência de
 * campo sem erro nenhum, ver `api/contrato-eventos-do-agente.unit.js`).
 */

/** `agent_sdk/busca_hook.py:73` — o host não está na allowlist do run. */
export const MOTIVO_DOMINIO_FORA_DA_ALLOWLIST = 'dominio_fora_da_allowlist'

/** `agent_sdk/busca_hook.py:74` — a consulta levava identificador de cliente. */
export const MOTIVO_IDENTIFICADOR_NO_TERMO = 'identificador_de_cliente_no_termo'

/**
 * `agent_sdk/busca_hook.py:511` (`MOTIVO_TETO_DE_BUSCAS`) — o teto de buscas do
 * TURNO barrou esta chamada. Publicado desde o commit `acf11821` do worker.
 *
 * ⚠️ **A negação NÃO impede o par `consulta`/`resultado` de sair.** O
 * `ToolUseBlock` já foi emitido quando o hook `PreToolUse` decide, e o
 * `tool_result` de erro do `deny` volta com `is_error` — logo o `resultado`
 * chega com zero fontes (`stream.py:252`). São TRÊS eventos para uma busca só, e
 * quem os funde é `utils/buscas-do-turno.js` (`ehEcoDeNegacao`). Sem isso o
 * consultor lê as duas frases sobre a mesma busca: "o limite acabou" e, logo
 * abaixo, "não encontrou resultados" — a segunda sendo a mentira que publicar a
 * negação foi corrigir.
 *
 * ⚠️ O payload da negação vem **sem `consulta`** (quem publica é o hook, que não
 * tem o termo à mão): é o fechamento da busca aberta que preserva o termo.
 *
 * ⚠️ E **não** é o `teto_excedido` de `agent_sdk/tools_mcp.py:97`: aquele é o
 * teto de ORÇAMENTO do RUN, vai para `registro_falha` e ENCERRA o run. Eixos
 * diferentes — confundi-los faria a tela dizer "faça outra pergunta" sobre um
 * run que não existe mais.
 *
 * 📌 Higiene pendente, com dono declarado: `d_busca` no
 * `contratos/events_agente.schema.json` **não lista** `motivo`/`ofensor`/
 * `permitido`, que o produtor publica há várias specs. Não fecha
 * `additionalProperties`, então nada quebra — mas o contrato descreve menos do
 * que o fio carrega. Sincronizar hoje esbarra em
 * `test_schema_embutido_e_identico_ao_canonico`, já vermelho por divergência
 * pré-existente e commitada.
 */
export const MOTIVO_TETO_DE_BUSCAS_DO_TURNO = 'teto_de_buscas_do_turno'
